import React from "react";
import { css } from "@linaria/core";
import { color } from "@ui";
import { CloseCircleFill, ErrorWarningFill } from "@ui/IconV2/react";
import type { AlertType } from "./useQuantityAlerts";

const iconCss = css`
  height: 16px;
  color: ${color.darkNitrogen600};
`;

function AlertIcon({ alertType = "measures" }: { alertType?: AlertType }) {
  return alertType === "symptoms" ? (
    <ErrorWarningFill className={iconCss} />
  ) : (
    <CloseCircleFill className={iconCss} />
  );
}

export default AlertIcon;
